import { PropsWithChildren } from 'react'

import { createStyles } from 'antd-style'

import { FloorBlock } from '../../../../components/FloorBlock'

import { ZoneBlockProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  root: {
    flex: 1,
    overflow: 'hidden'
  },
  header: {
    position: 'relative',
    paddingInline: 0,
    paddingBlock: token.paddingXXS
  },
  title: {
    fontSize: token.fontSizeLG
  },
  icon: {
    width: 3,
    height: '0.8em',
    backgroundColor: token.colorPrimary
  },
  body: {
    paddingBlockStart: token.paddingXS,
    boxShadow: 'none'
  }
}))

const BlockIcon = () => {
  const { styles } = useStyles()

  return <div className={styles.icon} />
}

export const ZoneBlock = ({
  className,
  ...restProps
}: PropsWithChildren<ZoneBlockProps>) => {
  const { cx, styles } = useStyles()

  return (
    <FloorBlock
      {...restProps}
      className={cx(styles.root, className)}
      icon={<BlockIcon />}
      classNames={{
        header: styles.header,
        title: styles.title,
        body: styles.body
      }}
    />
  )
}
